import type { ICampaignAnalyticMetricFunc, ICampaignAnalyticMetricDetectKey } from '../hooks';
import type { ICampaignMetricKey } from '~/modules/campaign-analytics/types';

import { IVariantType } from '~/modules/campaign/types';

export enum IAnalyticSummaryResult {
  BOTH_SIMILAR = 'BOTH_SIMILAR',
  NO_RESULT = 'NO_RESULT',
  VARIANT_A = IVariantType.VARIANT_A,
  VARIANT_B = IVariantType.VARIANT_B,
}

export interface IAnalyticSummaryMetricResult {
  variantWinner: IAnalyticSummaryResult;
  metricKey: ICampaignAnalyticMetricDetectKey;
}

export interface IAnalyticSummaryOutcome {
  overallResult: IAnalyticSummaryResult;
  winningVariant: IAnalyticSummaryResult.VARIANT_A | IAnalyticSummaryResult.VARIANT_B | null;
  winningMetrics: IAnalyticSummaryMetricResult[];
  similarMetrics: IAnalyticSummaryMetricResult[];
}

export interface IAnalyticSummaryVariantDisplay {
  icon: string;
  label: string;
  tone: 'active' | 'inactive';
  className: string;
}

export interface ICampaignAnalyticMapping {
  metricFuncKey: keyof ICampaignAnalyticMetricFunc;
  metricDataKey: ICampaignAnalyticMetricDetectKey;
  title: string;
  metricKey: ICampaignMetricKey;
}
